import { z } from 'zod';
import { ImportedSignalDraftResolutionStatusSchema } from '@terra/shared-schemas-orchestrator';

export const BugBountyImportFailedRowSchema = z.object({
  issueUrl: z.string().nullable(),
  providerExternalId: z.string().nullable(),
  externalSignalId: z.string().nullable(),
  description: z.string(),
  failureReason: z.string(),
  resolutionStatus: z.union([
    ImportedSignalDraftResolutionStatusSchema,
    z.literal('INGEST_FAILED'),
  ]),
});

export const BugBountyImportFailedRowsResponseSchema = z.object({
  sourceLabel: z.string(),
  scanRunKey: z.string().nullable(),
  rows: BugBountyImportFailedRowSchema.array(),
});

export type BugBountyImportFailedRow = z.infer<
  typeof BugBountyImportFailedRowSchema
>;
